export const STATUS_FORMAT = {
  STH: {
    101: 'dddd, MMMM D',
    102: 'dddd, MMMM D',
    105: 'dddd, MMMM D',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
  },
  BOSS: {
    101: 'dddd, MMMM D',
    102: 'dddd, MMMM D',
    105: 'dddd, MMMM D',
    130: 'dddd, MMMM D',
    131: 'dddd, MMMM D',
    132: 'dddd, MMMM D',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
    200: 'dddd, MMMM D',
  },
  BOPIS: {
    101: 'dddd, MMMM D',
    102: 'dddd, MMMM D',
    105: 'dddd, MMMM D',
    130: 'dddd, MMMM D',
    131: 'dddd, MMMM D',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
    200: 'dddd, MMMM D',
  },
  APPLIANCE: {
    101: 'dddd, MMMM D',
    102: 'dddd, MMMM D, ',
    105: 'dddd, MMMM D',
    108: 'dddd, MMMM D',
    109: 'dddd, MMMM D, ',
    110: 'dddd, MMMM D',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
    200: ' ',
  },
  BODFS: {
    101: 'dddd, MMMM D, ',
    105: 'MMMM D, h:mm a',
    109: 'dddd, MMMM D, ',
    111: 'dddd, MMMM D, ',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
  },
  DFS: {
    101: 'dddd, MMMM D, ',
    105: 'MMMM D, h:mm a',
    109: 'dddd, MMMM D, ',
    111: 'dddd, MMMM D, ',
    140: 'dddd, MMMM D',
    150: 'dddd, MMMM D',
    401: 'dddd, MMMM D, ',
    1000: 'dddd, MMMM D',
  },
};

export const DISPLAY_DELIVERY_WINDOW = {
  STH: {
    101: false,
    102: false,
    105: false,
  },
  BOSS: {
    101: false,
    102: false,
    105: false,
    130: false,
    131: false,
    132: false,
    200: false,
  },
  BOPIS: {
    101: false,
    102: false,
    105: false,
    130: false,
    131: false,
    200: false,
  },
  APPLIANCE: {
    101: false,
    102: true,
    105: false,
    108: false,
    109: true,
    110: false,
  },
  BODFS: {
    101: true,
    105: false,
    109: true,
    111: true,
  },
  DFS: {
    101: true,
    105: false,
    109: true,
    111: true,
    401: true,
    1000: false,
  },
};
